/* eslint-disable @typescript-eslint/no-explicit-any */
import { SearchIcon, XCircleIcon } from "lucide-react";
import { useEffect, useState } from "react";

export default function TextFilterComponent({
  name,
  handleChangeFilterByColumns,
  defaultFilterValue,
}: {
  name: string;
  handleChangeFilterByColumns: (key: string, value: any) => void;
  defaultFilterValue: any;
}) {
  const [valueState, setValueState] = useState<string>(
    defaultFilterValue?.[name] ?? "",
  );

  useEffect(() => {
    setValueState(defaultFilterValue?.[name] ?? "");
  }, [defaultFilterValue, name]);

  return (
    <div className="flex w-full items-center rounded-md bg-slate-100">
      <span className="flex-none pl-2 text-slate-500">
        <SearchIcon size={16} />
      </span>
      <input
        type="text"
        className="w-full flex-1 bg-transparent p-2 text-xs focus:outline-none"
        placeholder="Search..."
        value={valueState ?? ""}
        onChange={(e) => {
          const inputValue = (e.target as HTMLInputElement).value;
          setValueState(inputValue);

          if (inputValue === "") {
            handleChangeFilterByColumns(name, "");
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            let inputValue = (e.target as HTMLInputElement).value;
            if (inputValue === "-") {
              inputValue = "NULL";
            }
            handleChangeFilterByColumns(name, inputValue);
          }
        }}
      />
      <button
        className={`flex-none cursor-pointer pr-2 text-slate-500 ${
          valueState ? "visible" : "invisible"
        }`}
        onClick={() => {
          handleChangeFilterByColumns(name, "");
          setValueState("");
        }}
        aria-label="Clear filter" // Adding an aria-label for accessibility
      >
        <XCircleIcon size={16} />
      </button>
    </div>
  );
}
